import React, { useEffect, useRef  } from 'react';
import { withRouter, useHistory} from 'react-router-dom';
import "rc-switch/assets/index.css";

import {Form, FormGroup, Label, Input, Button, Row, Col, Table, Card, CardBody, CardTitle, CardText} from 'reactstrap';

import AppLayout from '../../components/AppLayout';
import styled from 'styled-components';

const SafetyStatement = ({
    user
}) => {

    const history = useHistory();

    useEffect(() => {
        if (!user.b_internal) {
            history.push('/EOS/Portal/Profile');
        }
    }, []);

    return (
        <AppLayout>
            <div className={`card queue-card-container`} style={{backgroundColor: 'white', height: 'calc(100vh - 120px)', overflowY: 'scroll'}}>
                <div className="card-body mb-5 px-5 py-3">
                    <Row className='px-3 py-3'>
                        <Col md='12' lg='12'>
                            <Row className='mb-2'>
                                <h1 style={{fontWeight: 'bold'}}>
                                    MANAGEMENT COMMITMENT - Safety Policy Statement
                                </h1>     
                            </Row>
                            <SafetyStatementImg src={require('../../assets/img/safety-policy.png')} />
                        </Col>
                    </Row>
                </div>
            </div>

        </AppLayout>
    );
}

export default withRouter(SafetyStatement);

const SafetyStatementImg = styled.img`
    width: 50%;
`;